<template>
  <section class="app__section__ernest">
    <resource-modal v-model="modal.display"/>
    <v-progress-circular
      indeterminate
      color="valid"
      v-if="pageLoaded"
    />

    <section id="app__content" v-else-if="this.resultNumber > 0">
      <section v-html="staticText"></section>

      <section v-if="feedbackSpecialText !== null" v-html="feedbackSpecialText"></section>

      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>Graphique</v-expansion-panel-header>
          <v-expansion-panel-content>
            <section id="chart__result">
              <v-progress-circular
                indeterminate
                color="valid"
                v-if="chartLoaded"
              />
              <chart @loaded="loaded.chart = true"/>
            </section>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Retours</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-expansion-panels>
              <v-expansion-panel v-for="(feedback, index) in feedbacks"
                                 :key="index"
              >
                <v-expansion-panel-header>{{ feedback.domainName }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <section v-html="feedback.text"></section>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Ressources proposées</v-expansion-panel-header>
          <v-expansion-panel-content>
            <section class="resources__container"
                     :class="{
                        gestionnaire__container: user.isStaff,
                        user__container: !user.isStaff
                     }">
              <ressource v-for="(resource, index) in resources"
                         :key="resource.id"
                         :resourceId="resource.id"
                         :class="{ miniature: isMiniature(index) }"
                         :is-miniature="isMiniature(index)"
              />
            </section>

            <v-expansion-panels>
              <v-expansion-panel @click.stop="onOpenAdditionalResources('completed')">
                <v-expansion-panel-header>Resources terminées</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <section id="resources__completed__container">
                    <v-progress-circular
                      indeterminate
                      color="valid"
                      v-if="resourceCompletedLoaded"
                    />
                    <section v-else
                             class="resources__container"
                             :class="{
                                gestionnaire__container: user.isStaff,
                                user__container: !user.isStaff
                             }"
                    >
                      <ressource v-for="(resource, index) in resourcesCompleted"
                                 :key="resource.id"
                                 :resourceId="resource.id"
                                 :class="{ miniature: isMiniature(index) }"
                                 :is-miniature="isMiniature(index)"
                                 resource-type="completed"
                      />
                    </section>
                  </section>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel @click.stop="onOpenAdditionalResources('discarded')">
                <v-expansion-panel-header>Ressources désactivées</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <section id="resources__discarded__container">
                    <v-progress-circular
                      indeterminate
                      color="valid"
                      v-if="resourceDiscardedLoaded"
                    />
                    <section v-else
                             class="resources__container"
                             :class="{
                                gestionnaire__container: user.isStaff,
                                user__container: !user.isStaff
                             }"
                    >
                      <ressource v-for="(resource, index) in resourcesDiscarded"
                                 :key="resource.id"
                                 :resourceId="resource.id"
                                 :class="{ miniature: isMiniature(index) }"
                                 :is-miniature="isMiniature(index)"
                                 resource-type="discarded"
                      />
                    </section>
                  </section>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

    </section>
    <div v-else>{{ $t('pages.results.noResult')}}</div>
    <v-btn class="button__return"
           color="cancel"
           @click="$router.push({ name: 'home_user' })"
    >{{ $t('pages.results.button.back') }}
    </v-btn>

    <v-btn class="button__return"
           v-if="this.user.isStaff"
           color="valid"
           @click="resetIterations"
    >{{ $t('pages.results.button.reset') }}
    </v-btn>
  </section>
</template>

<script>
import Chart from '@/components/appUser/results/Chart'
import Ressource from '@/components/appUser/results/Resource'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Results',
  components: {
    Chart,
    Ressource,
    ResourceModal: () => import('@/components/appUser/results/ResourceModal')
  },
  data () {
    return {
      feedbacks: [],
      feedbackSpecialText: null,
      loaded: {
        page: false,
        chart: false,
        resourceCompleted: false,
        resourceDiscarded: false
      },
      modal: {
        display: false
      },
      staticText: '',
      windowSize: 0
    }
  },
  computed: {
    ...mapGetters('Resources', [
      'resourceDisplayed',
      'resourcesDiscarded',
      'resourcesCompleted',
      'resources'
    ]),
    ...mapGetters('User', [
      'user'
    ]),
    ...mapGetters('UserQuestionnaire', [
      'results',
      'resultNumber',
      'specialFeedback'
    ]),
    chartLoaded () {
      return !this.loaded.chart
    },
    pageLoaded () {
      return !this.loaded.page
    },
    resourceCompletedLoaded () {
      return !this.loaded.resourceCompleted
    },
    resourceDiscardedLoaded () {
      return !this.loaded.resourceDiscarded
    },
    responsiveState () {
      if (this.user.isStaff) {
        return this.windowSize >= 1140
          ? 3
          : this.windowSize < 1140 && this.windowSize >= 940
            ? 2
            : this.windowSize < 940 && this.windowSize >= 720
              ? 1
              : 0
      } else {
        return this.windowSize >= 1140
          ? 4
          : this.windowSize < 1140 && this.windowSize >= 940
            ? 3
            : this.windowSize < 940 && this.windowSize >= 720
              ? 2
              : 0
      }
    }
  },
  watch: {
    resourceDisplayed () {
      this.modal.display = true
    }
  },
  async created () {
    await this.axios({
      method: 'GET',
      url: 'statictexts/utilisateur_page_de_resultats/'
    })
      .then(response => {
        this.staticText = response.data.text
      })

    this.loadUser()

    let questionnaireId = this.$route.params['id']
    await this.loadResources(questionnaireId)
    await this.loadResults(questionnaireId)

    this.feedbackSpecialText = this.specialFeedback

    this.results.forEach((domain, index) => {
      this.feedbacks[index] = {}
      this.feedbacks[index].domainName = domain.name
      this.feedbacks[index].text = `<ul>`

      domain.skills.sort((skill1, skill2) => {
        return skill1.order > skill2.order
          ? -1
          : skill1.order === skill2.order
            ? 0
            : 1
      })
        .forEach(skill => {
          this.feedbacks[index].text += `<li>${skill.feedback}</li>`
        })

      this.feedbacks[index].text += `</ul>`
    })

    this.loaded.page = true

    this.windowSize = window.innerWidth
    window.addEventListener('resize', () => {
      this.windowSize = window.innerWidth
    })
  },
  methods: {
    ...mapActions('Resources', [
      'loadResources',
      'loadAdditionalResources'
    ]),
    ...mapActions('User', [
      'loadUser'
    ]),
    ...mapActions('UserQuestionnaire', [
      'loadResults',
      'deleteFinishedIterations'
    ]),
    isMiniature (index) {
      return this.user.isStaff
        ? this.responsiveState !== 0 && index >= this.responsiveState
        : this.responsiveState !== 0 && this.responsiveState > 1 && index >= this.responsiveState
    },
    async resetIterations () {
      await this.deleteFinishedIterations()
    },
    async onOpenAdditionalResources (type) {
      console.log(type === 'completed', this.resourcesCompleted.length === 0)
      if (type === 'discarded' && this.resourcesDiscarded.length === 0) {
        await this.loadAdditionalResources({
          type,
          questionnaireId: this.$route.params['id']
        })
        this.loaded.resourceDiscarded = true
      } else if (type === 'completed' && this.resourcesCompleted.length === 0) {
        await this.loadAdditionalResources({
          type,
          questionnaireId: this.$route.params['id']
        })
        this.loaded.resourceCompleted = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/styleAppErnest";
  @import "../../../assets/style/responsive";

  .app__section__ernest {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .button__return {
      margin-top: 20px;
      width: 100%;
    }

    #app__content {
      display: flex;
      flex-direction: column;
      width: 100%;

      #chart__result {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      #chartDiv {
        height: 750px;
        width: 100%;
      }

      .resources__container {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr;
        grid-auto-rows: 400px;
        grid-gap: 10px;
        margin-bottom: 10px;

        &.user__container {
          @media all and (min-width: $small) {
            grid-auto-rows: 200px;
            grid-template-columns: repeat(4, 1fr);

            .resource__container:nth-child(1) {
              grid-column: 1/3;
              grid-row: 1/3;
            }

            .resource__container:nth-child(2) {
              grid-column: 3/5;
              grid-row: 1/3;
            }
          }

          @media all and (min-width: $medium) {
            grid-template-columns: repeat(6, 1fr);

            .resource__container:nth-child(3) {
              grid-column: 5/7;
              grid-row: 1/3;
            }
          }

          @media all and (min-width: $large) {
            grid-template-columns: repeat(8, 1fr);

            .resource__container:nth-child(4) {
              grid-column: 7/9;
              grid-row: 1/3;
            }
          }
        }

        &.gestionnaire__container {
          @media all and (min-width: $small) {
            .resource__container:nth-child(1) {
              grid-column: 1/3;
              grid-row: 1/3;
            }

            grid-auto-rows: 200px;
            grid-template-columns: repeat(2, 1fr);
          }

          @media all and (min-width: $medium) {
            grid-auto-rows: 200px;
            grid-template-columns: repeat(4, 1fr);

            .resource__container:nth-child(2) {
              grid-column: 3/5;
              grid-row: 1/3;
            }
          }

          @media all and (min-width: $large) {
            grid-template-columns: repeat(6, 1fr);

            .resource__container:nth-child(3) {
              grid-column: 5/7;
              grid-row: 1/3;
            }
          }
        }
      }

      #resources__completed__container, #resources__discarded__container {
        display: flex;
        justify-content: center;
      }
    }
  }
</style>
